import {HTTPGenericResponse} from "../../constants/FinanceModels";
import {useApi} from "../Api";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {getFilterValue} from "../../utils/FilterUtils";
import qs from "qs";
import {
    ID_FILTER_DEALER, ID_FILTER_LEGAL_ENTITY
} from "../../pages/refuelling/constants/ConstantsRefuelling";

export interface IRefuellingData {
    id: number;
    detectionDate: string;
    basePriceGas: number;
    basePriceDiesel: number;
    priceKwh: number;
    percentageIncreaseGas: number | null;
    percentageIncreaseDiesel: number | null;
    priceIncreaseGas: number;
    priceIncreaseDiesel: number;
}

export const useFuelCardsRepository = () => {
    const { GET, PUT } = useApi();

    const PATH = "/finance/refuelling/";
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    function loadRefuellingData(filterDefs: any): Promise<HTTPGenericResponse> {

        let legalEntity = getFilterValue(ID_FILTER_LEGAL_ENTITY, filterDefs) || allLegalEntities[0];
        let dealer = getFilterValue(ID_FILTER_DEALER, filterDefs);
        let params = {
            legalEntity, dealer
        }
        return GET(`${PATH}`, {
            params: params, paramsSerializer: (params) => qs.stringify(params,
                {arrayFormat: 'repeat', skipNulls: true})
        });
    }

    function saveRefuellingData(
            payload: IRefuellingData
    ): Promise<HTTPGenericResponse> {
        console.log("saveRefuellingData", payload);
        let p = {
            ...payload,
            percentageIncreaseGas: (payload.percentageIncreaseGas !== null) ? (payload.percentageIncreaseGas + "").replace(
                    ",",
                    "."
            ): null,
            percentageIncreaseDiesel: (payload.percentageIncreaseDiesel !== null) ? (payload.percentageIncreaseDiesel + "").replace(
                    ",",
                    "."
            ) : null,
            priceIncreaseGas: payload.priceIncreaseGas * 1000,
            priceIncreaseDiesel: payload.priceIncreaseDiesel * 1000,
            priceKw: payload.priceKwh * 1000
        };

        return PUT(`${PATH}`, p, {}, true);
    }

    return {
        loadRefuellingData,
        saveRefuellingData,
    };
};
